import React, { ReactNode, useState, useRef, useEffect, createRef } from "react";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import Input, { Search } from "../Input";
import { SelectContext } from "./selectContext";

const Select: React.FC<{
  className?: string;
  id?: string;
  defaultValue?: string;
  placeholder?: string;
  children: ReactNode | ReactNode[];
  handleSelectChange?: (option: any) => {};
  hasInput?: boolean;
  InputClass?: typeof Input | typeof Search; // 目前只支持Input和Search这两个
  inputProps?: any;
  inputRef?: React.RefObject<HTMLInputElement>;  // ref for input
  inputHandleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}> = (props) => {
    const {
      placeholder = "Select option",
      className,
      id,
      children,
      defaultValue = '',
      handleSelectChange,
      // 下面input相关熟悉是必须hasInput有效的时候使用的
      hasInput,
      inputHandleChange,
      inputRef,
      InputClass=Input,  // 默认是Input，也可以是Search
      inputProps={},
      // input相关逻辑结束
      ...abc
    } = props
    console.log(props)
    const [selectedOption, setSelectedOption] = useState(defaultValue || "");
    const [showDropdown, setShowDropdown] = useState(false);
    const selectPlaceholder = placeholder || "Choose an option";
    const selectContainerRef = useRef(null);
    const showDropdownHandler = () => setShowDropdown(!showDropdown);
    const clickOutsideHandler = () => setShowDropdown(false);

    useOnClickOutside(selectContainerRef, clickOutsideHandler);

    const updateSelectedOption = (option: string) => {
      setSelectedOption(option);
      setShowDropdown(false);
      handleSelectChange && handleSelectChange(option)
    };

    useEffect(() => {
      defaultValue && setSelectedOption(defaultValue);
    }, [defaultValue])

    const switchSpanOrInput = hasInput ? (
      <InputClass
        clear
        handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setShowDropdown((x) => true)
          inputHandleChange && inputHandleChange(e)
        }}
        inputRef={inputRef}
        {...inputProps}
      ></InputClass>
    ) : (
      <span className={`${selectedOption.length > 0 ? 'text-gray-900' : 'text-gray-300'}`}>{selectedOption.length > 0 ? selectedOption : selectPlaceholder}</span>
    )

    return (
      <SelectContext.Provider
        value={{ selectedOption, changeSelectedOption: updateSelectedOption }}
      >
        <div className={`relative w-full border border-gray-300 bg-white rounded-lg 
          ${showDropdown ? "border-sprimary-600" : "border-gray-300"}
          ${className}
        `}
          id={id}
          ref={selectContainerRef}
        >
          {/* 选择框 */}
          <div
            className={`${inputProps?.seleboxclass? inputProps.seleboxclass: 'p-2'} text-sm cursor-pointer flex flex-row items-center justify-between w-full text-gray-900 ${showDropdown ? "border-sprimary-600" : "border-gray-300"
              }`}
            onClick={showDropdownHandler}
          >
            {switchSpanOrInput}
            {/* 下拉 icon */}
            <svg className={`${showDropdown
              ? "rotate-180"
              : "rotate-0"
              } w-6 h-6 transform duration-200`} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path>
            </svg>
          </div>
          {/* 下拉菜单 */}
          <ul
            className={`absolute w-full bg-white mt-0.5 text-sm shadow-lg z-50
            ${showDropdown ? "block" : "hidden"}
          `}
          >
            {children}
          </ul>
        </div>
      </SelectContext.Provider>
    );
  };

export default Select;
